import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import { updateAccocunt } from '../appRedux/actions/accountAction';
import { updateAccountParent } from '../appRedux/services/AccountService';
import { eligibleParents, parentOptionLabels, parentOptionDetails } from '../app/routes/Admin/AccountChartPage/accountHierarchy';
import { QBO_ACCOUNT_TYPES, classificationOf, subTypesOf, subTypeLabel } from '../app/common/qboAccountTypes';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import { Icon, Select as AntSelect } from 'antd';
import './form.css';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// The antd select needs a value of its own for "no parent" (an empty value shows the placeholder).
const NO_PARENT = '__none__';


class EditAcccountForm extends React.Component {

    constructor() {
        super()
        this.state = {
            "accountID": '',
            "companyID": '',
            "listID": "",
            "name": "",
            "accountNumber": "",
            "accountType": "",
            "accountSubType": "",
            "classification": "",
            "description": "",
            "reviewStatus": "",
            "comments": "",
            "lastReconciledTransactionDate": null,
            "reconciledThrough": null,
            "parentRefListID": "",
            "saving": false,

        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
    }
    componentWillReceiveProps(nextProps) {

        if (this.props.visible !== nextProps.visible) {

            this.setState({
                "companyID": nextProps.selectedItem.companyID,
                "accountID": nextProps.selectedItem.accountID,
                "listID": nextProps.selectedItem.listID,
                "name": nextProps.selectedItem.name,
                "accountNumber": nextProps.selectedItem.accountNumber,
                "accountType": nextProps.selectedItem.accountType,
                "accountSubType": nextProps.selectedItem.accountSubType,
                "classification": nextProps.selectedItem.classification,
                "description": nextProps.selectedItem.description,
                "reviewStatus": nextProps.selectedItem.reviewStatus,
                "comments": nextProps.selectedItem.comments,
                "lastReconciledTransactionDate": nextProps.selectedItem.lastReconciledTransactionDate ? new Date(nextProps.selectedItem.lastReconciledTransactionDate) : null,
                "reconciledThrough": nextProps.selectedItem.reconciledThrough ? new Date(nextProps.selectedItem.reconciledThrough) : null,
                "parentRefListID": this.currentParent(nextProps),
                "saving": false,
            });
        }
    }

    // The parent as the chart shows it ('' = top-level).
    currentParent = (props = this.props) => {
        const item = props.selectedItem || {};
        return (item.listID && props.parentOf && props.parentOf.get(item.listID)) || '';
    }

    hasSubAccounts = () => {
        const listID = this.state.listID;
        if (!listID || !this.props.parentOf) return false;
        return Array.from(this.props.parentOf.values()).some((p) => p === listID);
    }

    handleCancel = () => {
        this.props.handleCancel()
    };

    setParent = (parentListId) => {
        return updateAccountParent(this.state.companyID, this.state.accountID, parentListId || null)
            .then((res) => {
                const body = res && res.data;
                if (body && body.transactionStatus !== 0) {
                    toast.error(body.resultMsg || 'Unable to update the parent account.');
                    return false;
                }
                return true;
            })
            .catch(() => {
                toast.error('Unable to update the parent account. Please refresh and try again.');
                return false;
            });
    }

    // The account update keeps the stored parent, so the parent is saved on its own. A sub-account must share its
    // parent's type: on a type change the old parent is removed first and the new one is set after the new type is saved.
    handleSubmit = async (e) => {
        e.preventDefault();
        const original = this.props.selectedItem || {};
        const oldParent = this.currentParent();
        const newParent = this.state.parentRefListID || '';
        const typeChanged = this.state.accountType !== original.accountType;
        let data = {
            "companyID": this.state.companyID,
            "accountID": this.state.accountID,
            "listID": this.state.listID,
            "name": this.state.name,
            "accountNumber": this.state.accountNumber,
            "accountType": this.state.accountType,
            "accountSubType": this.state.accountSubType,
            "subAccount": true,
            "classification": this.state.classification,
            "description": this.state.description,
            "isActive": true,
            "reviewStatus": this.state.reviewStatus,
            "comments": this.state.comments,
            "lastReconciledTransactionDate": this.state.lastReconciledTransactionDate != null ? moment(this.state.lastReconciledTransactionDate).format('YYYY-MM-DD') : null,
            "reconciledThrough": this.state.reconciledThrough != null ? moment(this.state.reconciledThrough).format('YYYY-MM-DD') : null,
        };

        this.setState({ saving: true });
        let parentNow = oldParent;
        if (typeChanged && oldParent) {
            if (!(await this.setParent(null))) {
                this.setState({ saving: false });
                return;
            }
            parentNow = '';
        }
        let saved = await this.props.updateAccocunt(data);
        if (saved && newParent !== parentNow) saved = await this.setParent(newParent);
        if (parentNow !== oldParent || newParent !== oldParent) this.props.reloadAccounts && this.props.reloadAccounts();
        this.setState({ saving: false });
        // Stays open with the error when any step fails, as in the new UI.
        if (saved) this.props.handleSave(false);
    }

    handleFormChange = (e, target) => {

        if (!target) {
            this.setState({ [e.target.name]: e.target.value })
        }
        else if (target == "lastReconciledTransactionDate") {
            this.setState({ lastReconciledTransactionDate: new Date(e) })
        }
        else if (target == "reconciledThrough") {
            this.setState({ reconciledThrough: new Date(e) })
        }
    }
    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    // A new type brings its own classification and detail types, and a parent must be of the same type.
    handleTypeChange = (event) => {
        const accountType = event.target.value;
        const subTypes = subTypesOf(accountType);
        this.setState((st) => ({
            accountType,
            classification: classificationOf(accountType) || st.classification,
            accountSubType: subTypes.indexOf(st.accountSubType) >= 0 ? st.accountSubType : (subTypes.length === 1 ? subTypes[0] : ''),
            parentRefListID: accountType === (this.props.selectedItem || {}).accountType ? this.currentParent() : '',
        }));
    }

    typeOptions = () => {
        const types = QBO_ACCOUNT_TYPES.map((t) => t.type);
        const current = this.state.accountType;
        return current && types.indexOf(current) < 0 ? [current].concat(types) : types;
    }

    subTypeOptions = () => {
        const subTypes = subTypesOf(this.state.accountType);
        const current = this.state.accountSubType;
        return current && subTypes.indexOf(current) < 0 ? [current].concat(subTypes) : subTypes;
    }

    // Same choices as the chart's Parent Account column, for the type picked here.
    parentOptions = () => {
        const all = this.props.accounts || [];
        const parentOf = this.props.parentOf || new Map();
        const item = this.props.selectedItem;
        if (!item) return [];
        const options = eligibleParents({ ...item, accountType: this.state.accountType }, all, parentOf);
        const current = this.state.parentRefListID;
        const currentAccount = current && !options.some((o) => o.listID === current) ? all.find((o) => o.listID === current) : null;
        return currentAccount ? [currentAccount].concat(options) : options;
    }

    render() {
        const { visible } = this.props;
        const lockType = this.hasSubAccounts();
        const parents = this.parentOptions();
        const parentLabels = parentOptionLabels(parents);
        const parentDetails = parentOptionDetails(parents, this.props.accounts || [], this.props.parentOf || new Map());

        return (
            <Dialog
                maxWidth="md"
                fullWidth={true}
                open={visible}
                onClose={this.handleCancel}
            >
                <form method="post" onSubmit={this.handleSubmit} autoComplete="off" style={{ padding: 20 }}>
                    <DialogTitle>Edit Account</DialogTitle>
                    <DialogContent>
                        <fieldset>
                            <Grid container spacing={24} >
                                <Grid item sm={6} >
                                    <TextField
                                        name="name"
                                        label="Name"
                                        fullWidth
                                        required={true}
                                        onChange={this.handleFormChange}
                                        defaultValue={this.state.name}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item sm={6} >
                                    <TextField
                                        name="accountNumber"
                                        label={"Account Number"}
                                        fullWidth
                                        onChange={this.handleFormChange}
                                        defaultValue={this.state.accountNumber}
                                        margin="normal"
                                    />
                                </Grid>

                            </Grid>
                            <Grid container spacing={24} >
                                <Grid item sm={6}>
                                    <FormControl fullWidth margin="normal" required disabled={lockType}>
                                        <InputLabel htmlFor="accountType" shrink>Account Type</InputLabel>
                                        <Select
                                            native
                                            value={this.state.accountType || ''}
                                            onChange={this.handleTypeChange}
                                            inputProps={{ name: 'accountType', id: 'accountType', required: true }}
                                        >
                                            <option value='' disabled>Select Account Type</option>
                                            {this.typeOptions().map((t) => <option key={t} value={t}>{t}</option>)}
                                        </Select>
                                        {lockType && <FormHelperText>This account has sub-accounts, so its type can't change here.</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item sm={6}>
                                    <FormControl fullWidth margin="normal" required>
                                        <InputLabel htmlFor="accountSubType" shrink>Account SubType</InputLabel>
                                        <Select
                                            native
                                            value={this.state.accountSubType || ''}
                                            onChange={this.handleChange('accountSubType')}
                                            inputProps={{ name: 'accountSubType', id: 'accountSubType', required: true }}
                                        >
                                            <option value='' disabled>Select Account SubType</option>
                                            {this.subTypeOptions().map((s) => <option key={s} value={s}>{subTypeLabel(s)}</option>)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={24} >
                                <Grid item sm={6}>
                                    {/* Set by the account type, as in QuickBooks. */}
                                    <TextField
                                        name="classification"
                                        label={"Classification"}
                                        fullWidth
                                        value={this.state.classification || ''}
                                        InputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    {/* Same searchable list as the chart's Parent Account column, drawn as an underline field. */}
                                    <FormControl fullWidth margin="normal" className="edit-account-parent">
                                        <InputLabel htmlFor="parentRefListID" shrink>Parent Account</InputLabel>
                                        <AntSelect
                                            id="parentRefListID"
                                            className="edit-account-parent-select"
                                            dropdownClassName="chart-accounts-parent-dropdown edit-account-parent-dropdown"
                                            dropdownStyle={{ zIndex: 1400 }}
                                            suffixIcon={<ArrowDropDown className="edit-account-parent-icon" />}
                                            value={this.state.parentRefListID || NO_PARENT}
                                            showSearch
                                            optionFilterProp="title"
                                            optionLabelProp="label"
                                            onChange={(v) => this.setState({ parentRefListID: v === NO_PARENT ? '' : v })}
                                        >
                                            <AntSelect.Option key={NO_PARENT} value={NO_PARENT} label="None" title="None">None</AntSelect.Option>
                                            {parents.map((p) => (
                                                <AntSelect.Option key={p.listID} value={p.listID} label={parentLabels.get(p.listID)} title={parentLabels.get(p.listID)}>
                                                    <span className="chart-accounts-parent-name">{parentLabels.get(p.listID)}</span>
                                                    <span className="chart-accounts-parent-detail">{parentDetails.get(p.listID)}</span>
                                                </AntSelect.Option>
                                            ))}
                                        </AntSelect>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={24} >
                                <Grid item sm={6}>
                                    <TextField
                                        name="description"
                                        label={"Description"}
                                        fullWidth
                                        onChange={this.handleFormChange}
                                        defaultValue={this.state.description}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    {/* Same label / underline / spacing as the text fields above. */}
                                    <FormControl fullWidth margin="normal">
                                        <InputLabel htmlFor="reviewStatus" shrink>Review Status</InputLabel>
                                        <Select
                                            native
                                            value={this.state.reviewStatus || ''}
                                            onChange={this.handleChange('reviewStatus')}
                                            inputProps={{
                                                name: 'reviewStatus',
                                                id: 'reviewStatus',
                                            }}
                                        >
                                            <option value=''>Select Status</option>
                                            <option value='Pending'>Pending</option>
                                            <option value='Reviewed'>Reviewed</option>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={24} >
                                <Grid item sm={12}>
                                    <TextField
                                        name="comments"
                                        label="Comments"
                                        placeholder="Comment"
                                        fullWidth
                                        multiline
                                        rowsMax={4}
                                        margin="normal"
                                        value={this.state.comments || ''}
                                        onChange={(e) => { this.setState({ comments: e.target.value }); }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={24}>
                                <Grid item sm={6} className="edit-account-date">
                                    <DatePicker
                                        selected={this.state.lastReconciledTransactionDate}
                                        onChange={(e) => this.handleFormChange(e, 'lastReconciledTransactionDate')}
                                        id="lastReconciledTransactionDate"
                                        name="lastReconciledTransactionDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        yearDropdownItemNumber={15}
                                        customInput={<TextField label="Last Reconciled Transaction Date" fullWidth margin="normal" InputLabelProps={{ shrink: true }} InputProps={{ endAdornment: <InputAdornment position="end"><Icon type="calendar" className="edit-account-date-icon" /></InputAdornment> }} />}
                                    />
                                </Grid>
                                <Grid item sm={6} className="edit-account-date">
                                    <DatePicker
                                        selected={this.state.reconciledThrough}
                                        onChange={(e) => this.handleFormChange(e, 'reconciledThrough')}
                                        id="reconciledThrough"
                                        name="reconciledThrough"
                                        showMonthDropdown
                                        showYearDropdown
                                        yearDropdownItemNumber={15}
                                        customInput={<TextField label="Reconciled Through" fullWidth margin="normal" InputLabelProps={{ shrink: true }} InputProps={{ endAdornment: <InputAdornment position="end"><Icon type="calendar" className="edit-account-date-icon" /></InputAdornment> }} />}
                                    />
                                </Grid>
                            </Grid>
                        </fieldset>

                    </DialogContent>
                    <DialogActions>
                        <Button type="submit" color="primary" disabled={this.state.saving}>
                            {this.state.saving ? 'Updating…' : 'Update'}
                </Button>
                        <Button onClick={this.handleCancel} color="primary" autoFocus disabled={this.state.saving}>
                            Cancel
                </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}



const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateAccocunt
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditAcccountForm);



